module.exports = __webpack_public_path__ + "static/media/you've been asleep-01.b16610be.png";